import styled from "styled-components";

export const FileInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const FileInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.75rem;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  gap: 0.25rem;

  .file-name {
    font-weight: 500;
    color: #495057;
    font-size: 0.875rem;
  }

  .file-details {
    font-size: 0.75rem;
    color: #6c757d;
  }
`;

export const ErrorText = styled.span`
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
`;
